import { jsx } from "react/jsx-runtime";
import React from "react";
import { string, bool, oneOfType, node, arrayOf } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** Adds children after `text` element. */
  children: oneOfType([
    /** Array of React elements */
    arrayOf(node),
    /** React element */
    node
  ]),
  prefix: string,
  className: string,
  sticky: bool
};
const TableHeader = (props) => {
  const {
    prefix = "",
    sticky,
    children,
    className,
    ...otherProps
  } = props;
  const classes = sticky || className ? cx(
    "table-header",
    sticky && `${prefix}table-header--sticky`,
    className
  ) : null;
  return /* @__PURE__ */ jsx("thead", { className: classes, ...otherProps, children });
};
TableHeader.propTypes = propTypes;
var TableHeader_default = TableHeader;
export {
  TableHeader_default as default
};
